import React, { useEffect } from 'react';

const appUrl = import.meta.env.VITE_APP_URL || 'https://app.cplng.org';

/**
 * LoginRedirect Component
 * Always redirects to the main Coupling app.
 */
const LoginRedirect: React.FC = () => {
  useEffect(() => {
    window.location.href = `${appUrl}/login?source=coupling-wnc`;
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
        <p className="mt-4 text-white text-lg">Redirecting to Coupling app...</p>
      </div>
    </div>
  );
};

export default LoginRedirect;
